import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';

interface ArticleLocationState {
  checkQuota?: boolean;
  checkLoanWaiver?: boolean;
}

export default (): ArticleLocationState => {
  const { state } = useLocation();
  return useMemo(() => (state as ArticleLocationState) || { checkQuota: true, checkLoanWaiver: true }, [state]);
};
